import Color from "color";
import WRAP from "WRAP-JS";
import * as FPEUtils from "../../../utils/FPEUtils";

const LABEL_PADDING = 2;
const DEFAULT_ICON_OFFSET_Y = {
	2: 16,
};

WRAP.Renderer.PointArea = function () {
	WRAP.Renderer.call(this);
	// const renderer = this;

	this.init = false;

	this.draw = function (layer, content, conf, context, style, data, revision, dl) {
		WRAP.Geo.check(layer, content, conf, context, style, data, revision, dl);

		//リビジョン & 言語 & timezone 変化チェックを追加
		let noChange = true;
		if (this.content_revision !== revision.content) {
			noChange = false;
		} else if (this.context_revision !== revision.context) {
			noChange = false;
		} else if (this.conf_revision !== revision.conf) {
			noChange = false;
		} else if (this.style_revision !== revision.style) {
			noChange = false;
		} else if (this.data_revision !== revision.data) {
			noChange = false
		} else if (this.locale !== WRAP.Core.locale) {
			noChange = false
		} else if (this.timeZone !== WRAP.Core.timezone) {
			noChange = false
		}

		if (noChange) {
			return;
		}

		layer.setStatus({ status: "invalid" });

		if (!this.init) {
			init(layer, conf.Attributes.externalLayer);
		}

		const root = data.retained.data;
		if (!root) {
			if ( data.status.index || data.status.data ) {
				layer.setStatus({status:"error", reason:"data load error."});
			}
			return;
		}

		if (data.status.data !== 'completed') {
			layer.setStatus({status:"error", reason:"data load error."});
		}

		const filter = conf.Attributes.filter || (() => true);

		layer.clear();
		root.forEach(v => {
			if (!filter(v.type)) {
				return;
			}
			const color = new Color(`#${v.color}`);
			let labelPosition = null;
			if (v.type === 1) {
				// 地点
				// 同心円
				if (Array.isArray(v.concentricCircles)) {
					v.concentricCircles.forEach(radius => {
						layer.addFeature(new WRAP.Geo.Feature.GeoArc({
							point: v.position,
							radius: radius,
							lineWidth: 1,
							strokeStyle: color.toString(),
						}));
					});
					const maxRadius = Math.max(...v.concentricCircles);
					const steps = 16;
					for (let i = 0; i < steps; i++) {
						const deg = i * 360.0 / steps;
						// const pos = WRAP.Geo.Util.gcPos(...v.position.slice().reverse(), deg, maxRadius / 1851.8518518518517);
						const pos = WRAP.Geo.getGCPoint(
							FPEUtils.convertWRAPPoint(...v.position.slice().reverse()),
							maxRadius,
							deg
						);
						layer.addFeature(new WRAP.Geo.Feature.GeoLine({
							path: [v.position, [pos.lonDegree(), pos.latDegree()]],
							lineWidth: 1,
							strokeStyle: color.toString(),
							method:'GC',
						}));
					}
				}

				// アイコン
				if (v.iconDisplay === 1 || (v.iconDisplay === 2 && context.zoom >= 11.0)) {
					//debug
					// layer.addFeature(new WRAP.Geo.Feature.Line({
					// 	point: v.position,
					// 	line: [
					// 		[-16, -16],
					// 		[-16,  16],
					// 		[ 16,  16],
					// 		[ 16, -16],
					// 		[-16, -16],
					// 	],
					// 	strokeStyle: 'black',
					// 	lineWidth:1,
					// }));
					if (v.iconId > 0 && v.iconId <= 100) {
						// デフォルトアイコン
						const svgElement = document.getElementById(`default_icon_${v.iconId}`);
						svgElement.style.fill = color.toString();

						let svgData = new XMLSerializer().serializeToString(svgElement);
						const img = "data:image/svg+xml;base64,"
									+ btoa(unescape(encodeURIComponent(svgData)));

						const offsetY = DEFAULT_ICON_OFFSET_Y[v.iconId] || 0;
						const feature = new WRAP.Geo.Feature.Image({
							point: v.position,
							image: img,
							width: 32,
							height: 32,
							offsetX: -16,
							offsetY: -16 - offsetY,
						});
						feature.data = v;
						layer.addFeature(feature);
					} else if (v.path) {
						// カンパニーアイコン
						const feature = new WRAP.Geo.Feature.Image({
							point: v.position,
							image: v.path,
							width: 32,
							height: 32,
							offsetX: -16,
							offsetY: -16,
						});
						feature.data = v;
						layer.addFeature(feature);
					}
					labelPosition = v.position;
				}
			} else if (v.type === 2) {
				// サークル
				const feature = new WRAP.Geo.Feature.GeoArc({
					point: v.position,
					radius: v.radius,
					lineWidth: 1,
					strokeStyle: color.toString(),
					fillStyle: color.alpha(0.3).toString(),
				});
				feature.data = v;
				layer.addFeature(feature);
				labelPosition = v.position;
			} else if (v.type === 3) {
				// ポリゴン
				const feature = new WRAP.Geo.Feature.GeoLine({
					path: v.position,
					lineWidth: 1,
					strokeStyle: color.toString(),
					fillStyle: color.alpha(0.3).toString(),
					method:'GC',
				});
				feature.data = v;
				layer.addFeature(feature);
				labelPosition = v.centroid;
			}

			if (v.labelDisplay === 1 && labelPosition) {
				const labelOffset = calcLabelOffset(v);
				makeLabel(labelPosition, v.name, labelOffset, color).forEach(f => layer.addFeature(f));

				//debug
				// layer.addFeature(new WRAP.Geo.Feature.Point({
				// 	point: v.position,
				// 	pointSize: 5,
				// 	fillStyle:'black'
				// }));
			}

		})

		this.content_revision = revision.content;
		this.context_revision = revision.context;
		this.conf_revision = revision.conf;
		this.style_revision = revision.style;
		this.data_revision = revision.data;
		this.locale = WRAP.Core.locale;
		this.timeZone = WRAP.Core.timezone;

		layer.setStatus({ status:"valid" });
		WRAP.Geo.invalidate();
	}

	const calcLabelOffset = data => {
		if (data.type !== 1) {
			return 0;
		}
		const offset = DEFAULT_ICON_OFFSET_Y[data.iconId] || 0;
		return 16 - offset + LABEL_PADDING + 10;
	}

	const makeLabel = (labelPosition, text, offset, color) => {
		const fontSize = 12;
		const [w, h] = WRAP.Geo.getTextMetrics(text, fontSize);
		const offsetY = offset;
		const hw = w / 2;
		const hh = h / 2;

		const backgroundFeature = new WRAP.Geo.Feature.Line({
			point: labelPosition,
			// line: [
			// 	[hw + LABEL_PADDING, hh + LABEL_PADDING + offsetY],
			// 	[hw + LABEL_PADDING, -(hh + LABEL_PADDING) + offsetY],
			// 	[-(hw + LABEL_PADDING), -(hh + LABEL_PADDING) + offsetY],
			// 	[-(hw + LABEL_PADDING), hh + LABEL_PADDING + offsetY],
			// 	[hw - LABEL_PADDING, hh + LABEL_PADDING + offsetY],
			// ],
			line: FPEUtils.makeRoundedRectangle([
				[hw + LABEL_PADDING, hh + LABEL_PADDING + offsetY],
				[-(hw + LABEL_PADDING), -(hh + LABEL_PADDING) + offsetY],
			], 4),
			strokeStyle: color.toString(),
			fillStyle: color.alpha(0.7).toString(),
			lineWidth:1,
		});

		const labelFeature = new WRAP.Geo.Feature.Text({
			point: labelPosition,
			text: text,
			offsetY: hh + offsetY - 2,
			fontSize: fontSize,
			align:'center',
			fillStyle: 'white',
		});

		return [backgroundFeature, labelFeature];
	};

	const init = (layer, externalLayer) => {
		const myLayer = layer;
		let features = null;
		WRAP.Geo.addEventHandler('mouseover', (layer, feature, point) => {
			if (layer !== myLayer) return;
			const data = feature.data;
			if (data) {
				if (data.labelDisplay === 2) {
					const labelPosition = data.type !== 3 ? data.position : data.centroid;
					const labelOffset = calcLabelOffset(data);
					const color = new Color(`#${data.color}`);
					features = makeLabel(labelPosition, data.name, labelOffset, color);
					features.forEach(f => (externalLayer || layer).addFeature(f));
					WRAP.Geo.invalidate();
				}
			}
		});
		WRAP.Geo.addEventHandler('mouseout', (layer, feature, point) => {
			if (layer !== myLayer) return;
			if (Array.isArray(features)) {
				features.forEach(f => (externalLayer || layer).removeFeature(f));
				WRAP.Geo.invalidate();
			}
			features = null;
		});
		this.init = true;
	};

};
/* eslint-enable */
